export default class Gateway {
  constructor(gatewayId) {
    this.id = gatewayId
  }

  // performPayment() {
  // }
}
